import { Backdrop, Box, CircularProgress } from 'src/components';

export default function MapBackdrop({
  open,
  isMobile,
  isDesktopViewExpanded,
  mobileDrawerState,
  contentBgColor,
  showSpinner = false,
  message = '',
}) {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: 0,
        backgroundColor: `rgba(0, 0, 0, 0.1)`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
        mt: isMobile ? 0 : '60px',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: isMobile ? '30%' : '50%',
          left: '50%',
          transform: isMobile
            ? 'translate(-50%, -30%)'
            : 'translate(-50%, -50%)',
          ml: isMobile ? 0 : isDesktopViewExpanded ? 20 : 0,
          mt:
            !isMobile
              ? 0
              : mobileDrawerState === 'half' ||
                mobileDrawerState === 'expanded'
              ? 0
              : 15,
          bgcolor: contentBgColor,
          opacity: open ? 1 : 0,
          transition:
            'opacity 0.6s ease, transform 0.6s ease, margin-left 0.6s ease, margin-top 0.6s ease',
          borderRadius: 2,
          px: 1,
          py: 0.5,
          width: showSpinner ? 'auto' : '205px',
          justifyContent: 'center',
        }}
      >
        {showSpinner ? <CircularProgress /> : message}
      </Box>
    </Backdrop>
  );
}
